// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1P5UP","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__3Dafz"};